export const projectData = {
  name: "Godrej Varanya",
  location: "Sector 5A, Kharghar, Navi Mumbai",

  bannerImg: [
    "/Images/BANNER/1.jpg",
    "/Images/BANNER/2.jpg",
    "/Images/BANNER/3.jpg",
  ],

  overview:
    "Godrej Varanya is a premium residential project in Kharghar offering thoughtfully designed 2 and 3 BHK apartments. Enjoy smart layouts with excellent ventilation, abundant natural light and lush green surroundings. The project features world class amenities including a clubhouse, swimming pool, gymnasium, yoga zone, kids’ play area and sports courts. Located in the heart of Navi Mumbai, it offers seamless connectivity to schools, hospitals, malls and recreational hubs. Close proximity to Sion Panvel Highway, Metro Station, Kharghar Railway Station and Navi Mumbai International Airport ensures ease of travel. Godrej Varanya perfectly blends modern comfort, connectivity and a serene lifestyle in Kharghar.",

  highlights: [
    "Sprawling 6.5 Acre prime residential land parcel setting",
    "Spacious 2 & 3 BHK residences in Prime location Kharghar",
    "State of the art clubhouse with curated amenities",
    "One minute access to metro, rail, highways connectivity",
    "Surrounded entirely by serene hillside green vistas",
    "Ample parking spaces for residents and guests",
    "Eco-conscious planning and High end security",
    "Twenty minutes from Navi Mumbai International Airport",
  ],

  configurations: [
    { type: "2 BHK", area: "725 - 775", price: "₹ 2.25 – 2.39 Cr*" },
    { type: "3 BHK", area: "1100 - 1200", price: "₹ 3.99 – 4.39 Cr*" },
  ],

  floorPlan: ["/Images/FLOOR PLAN/1.jpg", "/Images/FLOOR PLAN/2.jpg"],

  amenities: [
    { title: "Indoor Games", img: "/Images/AMENITIES/indoorgamesarea.jpg" },
    { title: "Gymnasium", img: "/Images/AMENITIES/gymnasium.jpg" },
    { title: "Landscaped Gardens", img: "/Images/AMENITIES/garden.jpg" },
    { title: "Clubhouse", img: "/Images/AMENITIES/clubhouse.jpg" },
    { title: "Kids Play Area", img: "/Images/AMENITIES/kidsplayarea.jpg" },
    { title: "Swimming Pool", img: "/Images/AMENITIES/swimmingpool.jpg" },
  ],
  gallary: [
    "/Images/GALLARY/1.jpg",
    "/Images/GALLARY/2.jpg",
    "/Images/GALLARY/3.jpg",
    "/Images/GALLARY/4.jpg",
  ],

  connectivityData: [
    {
      title: "Connectivity",
      items: [
        "Sion – Panvel Highway – 02 Min",
        "Kharghar Railway Station – 01 Min",
        "Navi Mumbai International Airport – 20 Min",
        "Atal Setu - 20 Min",
      ],
    },
    {
      title: "Education Hub",
      items: [
        "National Institute of Fashion Technology (NIFT) – 02 Min",
        "AC Patil College of Engineering – 03 Min",
        "Bal Bharati Public School – 03 Min",
        "Ryan International School – 08 Min",
      ],
    },
    {
      title: "Healthcare",
      items: [
        "Mitr Hospital, Kharghar – 02 Min",
        "Medicover Hospital – 05 Mins",
        "Tata Memorial Hospital, Kharghar – 08 Min",
      ],
    },
    {
      title: "Malls / Shopping",
      items: [
        "Glomax Mall – 04 Min",
        "Little World Mall – 05 Min",
        "Reliance Smart Superstore – 05 Min",
        "D Mart – 10 Min",
      ],
    },
  ],
};
